import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbsComponent } from './bread-crumbs.component';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { ApplicationPipesModule } from 'src/app/pipe/pipes.module';




@NgModule({
  declarations: [
    BreadCrumbsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
    ApplicationPipesModule
  ],
  exports: [
    BreadCrumbsComponent,
  ]
})
export class BreadCrumbsModule { }
